import * as React from 'react';
import { connect } from 'react-redux';
import { getRoadConditions, getRoadSurfaceTypes, handleNextStep, handleStepBack, setFnolReducer, setReducer } from '../../../actions/claimSubmitActions';
import { SET_CLAIM_DATA } from '../../../constants/constants';
import { IDropdownData } from '../../../interfaces/KPDropdown/KPDropdownInterfaces';
import KPDropdown from '../../BaseTemplate/SSPCustomComponentLibrary/KPDropdown/KPDropdown';
import ReactTooltip from "react-tooltip";
import { isMobile } from 'react-device-detect';

class RoadSurface extends React.Component<any, any>  {
    constructor(props) {
        super(props);

        this.state = {
            isPhotosTaken: undefined,
            nextDisabled: true,
        }
        this.handleNext = this.handleNext.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.handleIsPhotosTaken = this.handleIsPhotosTaken.bind(this);
        this.handleCheckValidation = this.handleCheckValidation.bind(this);
        this.handleSelection = this.handleSelection.bind(this);
    }

    async componentDidMount() {
        this.props.dispatchAction(getRoadSurfaceTypes());
        this.props.dispatchAction(getRoadConditions());
        this.setState({ isPhotosTaken: this.props.claimSubmit.potholePhotoTaken });
        this.handleCheckValidation();
    }

    async handleSelection(e: any, selectionType: any) {
        await this.props.dispatchAction(setReducer(SET_CLAIM_DATA, selectionType, Number(e)));
        this.handleCheckValidation();
    }

    handleCheckValidation() {
        var roadSurface = this.props.claimSubmit.selectedRoadSurfaceTypes
        var roadCondition = this.props.claimSubmit.selectedRoadConditions
        var photosTaken = this.props.claimSubmit.potholePhotoTaken
        if (roadSurface !== "" && roadCondition !== "" && ((photosTaken !== undefined && this.props.claimSubmit.followUpType === "pothole") || this.props.claimSubmit.followUpType !== "pothole")) {
            this.setState({ nextDisabled: false });
        }
        else {
            this.setState({ nextDisabled: true });
        }
    }

    handleNext() {
        this.handleCheckValidation();
        this.props.dispatchAction(handleNextStep())
    }

    handleBack() {
        this.props.dispatchAction(handleStepBack())
    }

    async handleIsPhotosTaken(photosTaken) {
        await this.props.dispatchAction(setFnolReducer("potholePhotoTaken", photosTaken));
        await this.setState({ isPhotosTaken: photosTaken });
        await this.handleCheckValidation();
    }

    public render() {
        let roadSurfaceTypes = this.props.claimSubmit.roadSurfaceTypes;
        let roadSurfaceTypesDropdown = [] as Array<IDropdownData>;
        let roadConditions = this.props.claimSubmit.roadConditions;
        let roadConditionsDropdown = [] as Array<IDropdownData>;

        if (roadSurfaceTypes.length > 0) {
            roadSurfaceTypesDropdown = this.props.claimSubmit.roadSurfaceTypes.map((item) => {
                let tempDropdown: IDropdownData = {
                    description: item.description,
                    id: String(item.id),
                    image: "",
                    productName: ""
                };
                return tempDropdown;
            });
        }

        if (roadConditions.length > 0) {
            roadConditionsDropdown = this.props.claimSubmit.roadConditions.map((item) => {
                let tempDropdown: IDropdownData = {
                    description: item.description,
                    id: String(item.id),
                    image: "",
                    productName: ""
                };
                return tempDropdown;
            });
        }

        return <>
            <div className="col ssp-container-fnol-claim-info ssp-container-fnol-step-header-padding road-surface">
                <div className="row noma">
                    <div className="col-12 nopa ssp-header-fnol-claim-info">
                        <div className="row noma">
                            <div className="fnol-step-header-icon-area">
                                <img src={'/my-policy/Images/Claims/Numbers/' + this.props.claimSubmit.selectedClaimStep.stepLabel + '-red.png'} alt={"Step " + this.props.claimSubmit.selectedClaimStep.stepLabel} title={"Step " + this.props.claimSubmit.selectedClaimStep.stepLabel} />
                            </div>
                            <div className="col fnol-step-header-title-area">
                                <h3>{this.props.claimSubmit.selectedClaimStep.title}</h3>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row noma">
                    <div className="col-12 nopa">
                        <hr className="hr-minus21px" />
                        <p className="font-weight-normal line-height-normal mb-20px">We need a few more details to process your claim:</p>
                    </div>
                    <div className="col-12 nopa" title="SSP List Dropdown">
                        <div className="road-surface-form">
                            <div className="form-group mb-0px">
                                <KPDropdown id={"claim-road-surface-dropdown"}
                                    isImageDropdown={false}
                                    showLabelAfterSelection={true}
                                    showLabelInside={true}
                                    showLabelOutside={false}
                                    isRiskItem={false}
                                    labelAfterSelection={"What type of road surface was it"}
                                    title={"What type of road surface was it"}
                                    label={"What type of road surface was it"}
                                    data={roadSurfaceTypesDropdown}
                                    handleSelection={(e) => this.handleSelection(e, 'selectedRoadSurfaceTypes')}
                                    selectedValue={roadSurfaceTypesDropdown.find(x => x.id == this.props.claimSubmit.selectedRoadSurfaceTypes)} />
                            </div>
                        </div>
                    </div>
                    <div className="col-12 nopa mt-20px" title="SSP List Dropdown">
                        <div className="road-surface-form">
                            <div className="form-group mb-0px">
                                <KPDropdown id={"claim-road-conditions-dropdown"}
                                    isImageDropdown={false}
                                    showLabelAfterSelection={true}
                                    showLabelInside={true}
                                    showLabelOutside={false}
                                    isRiskItem={false}
                                    labelAfterSelection={"What was the condition of the road surface"}
                                    title={"What was the condition of the road surface"}
                                    label={"What was the condition of the road surface"}
                                    data={roadConditionsDropdown}
                                    handleSelection={(e) => this.handleSelection(e, 'selectedRoadConditions')}
                                    selectedValue={roadConditionsDropdown.find(x => x.id == this.props.claimSubmit.selectedRoadConditions)} />
                            </div>
                        </div>
                    </div>
                </div>
                {this.props.claimSubmit.followUpType === "pothole" &&
                    <>
                        <div className="row noma roadSurface-parent-row mt-30px">
                            <div className="col nopa">
                                <p className="font-size-16px glassclaims-intro-p mt-10px"><b>Did you take a photo of the pothole <img className={isMobile ? "ml-10px mb-0 completionTooltip mobile-right-follow-up" : "ml-10px mb-0 completionTooltip"} id="completionTooltip" alt="" src="./images/icons-line-style-info-32-px.svg" data-tip data-for="ThirdPartyToolTip" />
                                    <ReactTooltip arrowColor="transparent" className="thirdpartytooltip" id="ThirdPartyToolTip" place={isMobile ? "top" : "right"} effect="solid">
                                        Should your claim be approved, this could help with the recovery of your excess.
                                    </ReactTooltip></b></p>
                            </div>
                            <div className="nopa text-lg-right roadSurface-button-col">
                                <div className="row noma roadSurface-button-row">
                                    <div className="col nopa roadSurface-button-no">
                                        <button id="btnPhotoTakenNo" className={!this.state.isPhotosTaken && this.state.isPhotosTaken !== undefined ? "btn btn-outline-dark nopa fnol-repairs-button active" : "btn btn-outline-dark nopa fnol-repairs-button"} onClick={() => this.handleIsPhotosTaken(false)}>No</button>
                                    </div>
                                    <div className="roadSurface-mobile-gutter nopa"></div>
                                    <div className="col nopa roadSurface-button-yes">
                                        <button id="btnPhotoTakenYes" className={this.state.isPhotosTaken && this.state.isPhotosTaken !== undefined ? "btn btn-outline-dark nopa fnol-repairs-button active" : "btn btn-outline-dark nopa fnol-repairs-button"} onClick={() => this.handleIsPhotosTaken(true)}>Yes</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {this.state.isPhotosTaken && this.state.isPhotosTaken !== undefined &&
                            <div className="row noma mt-20px">
                                <div className="col-12 nopa">
                                    <p className="font-weight-normal line-height-normal mb-0px">Great! Please pop us an email with the photo to <a className="font-weight-bold text-red" href="mailto:claims@kingprice.co.za" target="_blank">claims@kingprice.co.za</a> and use your claim number <strong>({this.props.profile.selectedPersonalClaim.claimNumber})</strong> in the subject line.</p>
                                </div>
                            </div>
                        }
                    </>
                }
                <div className="row noma road-surface-footer">
                    <div className="col-12 nopa">
                        <hr className="hr-minus21px" />
                    </div>
                </div>
            </div>
            <div className="col-12 nopa fnol-where-it-happened-buttonholder pb-20px">
                <button className="btn btn-solid-red fnol-buttonreverse-button-next" id="btnRoadSurfaceNext" onClick={this.handleNext} disabled={this.state.nextDisabled}>Next</button>
                <button className="btn btn-outline-red fnol-buttonreverse-button-back" id="btnRoadSurfaceBack" disabled={this.props.claimSubmit.followUpType != 'multiple-collision'} onClick={this.handleBack}>Back</button>
            </div>
        </>
    }
}

const mapStateToProps = (state: any) => {
    return {
        props: state.loadingScreen,
        profile: state.profile,
        claimSubmit: state.claimSubmit,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(RoadSurface)